import {Component, inject, OnInit} from '@angular/core';
import {BaseOverlayComponent} from "../../../../shared/components/overlay/base-overlay/base-overlay.component";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {DropdownComponent} from "../../../../shared/inputs/dropdown/dropdown.component";
import {BaseComponent} from "../../../../shared/base/base-component";
import {ApiService} from "../../../../core/api/api.service";
import type {
  CreateCompanyRequest,
  CreateCompanyResponse, GetCompanyTypeListResponse
} from "../../../../core/api/model";
import {State} from "../../../../shared/base/base-state";
import {DialogRef} from "@angular/cdk/dialog";
import {ButtonComponent} from "../../../../shared/components/button/button.component";
import {TextInputComponent} from "../../../../shared/inputs/text-input/text-input.component";

@Component({
  selector: 'app-create-new-company',
  imports: [
    BaseOverlayComponent,
    ReactiveFormsModule,
    DropdownComponent,
    ButtonComponent,
    TextInputComponent
  ],
  templateUrl: './create-new-company.component.html',
  standalone: true,
  styleUrl: './create-new-company.component.scss'
})
export class CreateNewCompanyComponent extends BaseComponent implements OnInit {

  apiService = inject(ApiService);

  formBuilder = inject(FormBuilder);
  dialogRef = inject(DialogRef);
  createNewCompanyForm!: FormGroup;

  createNewCompanyState = new State<CreateCompanyResponse>();
  companyTypesState = new State<GetCompanyTypeListResponse>();

  ngOnInit(): void {
    this.initForm();
    this.getCompanyTypes();
  }

  initForm() {
    this.createNewCompanyForm = this.formBuilder.group({
      firstName: [null, Validators.required],
      lastName: [null],
      companyType: [null, Validators.required],
      phoneNumber: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      password: [null, Validators.required],
      companyName: [null, Validators.required],
      dotNumber: [null, Validators.required],
    });
  }

  getCompanyTypes() {
    this.executeRequest<GetCompanyTypeListResponse>({
      state: this.companyTypesState,
      request: this.apiService.getCompanyTypeList(),
    });
  }

  onCreateNewCompanyClicked() {
    if (this.createNewCompanyForm.invalid) {
      return;
    }
    let formValue = this.createNewCompanyForm.value;
    let request: CreateCompanyRequest = {
      companyName: formValue.companyName,
      companyType: formValue.companyType,
      dotNumber: formValue.dotNumber,
      email: formValue.email,
      firstName: formValue.firstName,
      lastName: formValue.lastName,
      password: formValue.password,
      phoneNumber: formValue.phoneNumber,
    }
    this.executeRequest({
      state: this.createNewCompanyState,
      request: this.apiService.createCompany(request),
      handleSuccess: true,
      onSuccess: (response) => {
        this.dialogRef.close(true);
      }
    });
  }
}
